import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { VendorService } from './shared/services/vendor.service';
// import { MemoizedApiService } from './shared/services/memoized-api.service';
import { filter } from 'rxjs/operators';
import { VendorResponse } from './shared/interfaces/hiring-manager.model';
import { AuthService } from './core/auth.service';
import { VendorDetails } from './shared/interfaces/vendor.model';
import { DataService } from './shared/services/data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  renderHeader = true;
  renderFooter = true;
  currentVendor: VendorDetails | null | undefined = null;
  userEmail: string | undefined | null = null;
  isMobileNavOpen = false;
  isAuthenticated = false;

  /**
   * iSkill renders its own dark sidebar — when we're on `/iskill/*` routes
   * we hide the host's left rail and drop the `.content` padding so the
   * iSkill shell takes the full width. Avoids the "dual navigation" look.
   */
  iskillFullScreen = false;


  constructor(
    private readonly router: Router,
    private readonly vendorService: VendorService,
    private readonly authService: AuthService,
    private readonly dataService: DataService, // Inject DataService
    // private readonly memoizedApiService: MemoizedApiService, // Inject MemoizedApiService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Save the current route for refresh scenarios (excluding login/callback and root)
        if (event.url !== '/' && event.url !== '/login' && !event.url.includes('/login/callback')) {
          sessionStorage.setItem('lastVisitedRoute', event.url);
        }

        // iSkill takes over the content area — host side rail + .content
        // padding hide so the dark green iSkill sidebar sits flush.
        this.iskillFullScreen = event.url.startsWith('/iskill');

        const contentSection = document.querySelector('.content');
        if (contentSection) {
          contentSection.scrollTop = 0;
        }
      }
    });
  }

  toggleHeader() {
    this.renderHeader = !window.location.pathname.includes('login');
  }

  toggleFooter() {
    this.renderFooter = !window.location.pathname.includes('login');
  }

  ngOnInit() {
    this.toggleHeader();
    this.toggleFooter();

    // Check authentication status
    this.checkAuthenticationStatus();

    this.userEmail = this.authService.oktaUserProfile?.email?.toLowerCase();
    this.vendorService.fetchVendorDetails().subscribe(
      (response: VendorResponse) => {
        const vendorDetails = response.data.vendors;
        this.vendorService.setVendorDetails(vendorDetails);
        this.currentVendor = this.userEmail
          ? vendorDetails.find(
              (vendor) =>
                Array.isArray(vendor.email) &&
                vendor.email.some((email) =>
                  email
                    ?.toLowerCase()
                    .includes((this.userEmail as string).toLowerCase()),
                ),
            )
          : null;
        this.vendorService.setCurrentVendor(this.currentVendor); // Set currentVendor in the service
      },
      (error) => {
        console.error('Failed to fetch vendor details', error);
      },
    );
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.toggleHeader();
        this.toggleFooter();
      });
    this.dataService.loadData();
    // Eagerly load dropdown data for modals
  }

  checkAuthenticationStatus() {
    // Initial authentication check
    this.updateAuthenticationStatus();

    // Listen to router events to check authentication on navigation
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateAuthenticationStatus();
      });
  }

  private updateAuthenticationStatus() {
    this.isAuthenticated = !!(
      this.authService.oktaUserProfile && this.authService.userProfile
    );
  }
}
